import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { useFirebaseApp } from '@rainbow-modules/firebase-hooks';
import getUserProfile from '../services/getUserProfile';
export default function useUserProfile() {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      userProfile = _useState2[0],
      setUserProfile = _useState2[1];

  var app = useFirebaseApp();
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var userProfile;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserProfile(app);

            case 2:
              userProfile = _context.sent;
              setUserProfile(userProfile);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [app]);
  return userProfile;
}